import { getDaysDifference, setTimeToMidnight } from "PFApp/booking/parts/overview/calendar/calendar.utils";
import { Booking } from "PFTypes";

export const getBookingDatesDiff = (booking: Booking, startDate: string, endDate: string): number =>
  getDaysDifference(
    setTimeToMidnight(new Date(startDate)),
    setTimeToMidnight(new Date(booking.start_date))
  ) || getDaysDifference(setTimeToMidnight(new Date(endDate)), setTimeToMidnight(new Date(booking.end_date)));
